import React, {Component} from 'react';
import * as firebase from 'firebase';
import AdSense from 'react-adsense';
import {Link} from 'react-router-dom';
import ReactLoading from 'react-loading';

export default class ADPost extends Component {
    constructor() {
        super();
        this.state = {
          listOfHotPositions: [],
          listOfPositions: [],
          loading: true
        }
    }
    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 2500);
        const blogsHotRelatedRef = firebase.database().ref('MedicalTeamPosts/');
        blogsHotRelatedRef.on('value', snap => {
          var i = [];
          var rand = Math.floor(Math.random(this.state.id) * snap.numChildren());
          snap.forEach((childArticle) => {
            const hotpreviousList = this.state.listOfHotPositions;
            if(i === rand) {
              hotpreviousList.push({
                HotblogName: childArticle.val().blogName,
                HotcreateDate: childArticle.val().createDate,
                HotcreateTime: childArticle.val().createTime,
                HotblogTag: childArticle.val().blogTag,
                HotsecondTag: childArticle.val().secondTag,
                HototherTag1: childArticle.val().otherTag1,
                HototherTag2: childArticle.val().otherTag2,
                HotlistPhoto: childArticle.val().croppedImg ? childArticle.val().croppedImg : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                Hotid: childArticle.val().id,
                Hotauthor: childArticle.val().author,
                HotauthorUrl: childArticle.val().authorUrl,
                HotName: childArticle.val().name,
                theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + childArticle.val().userId,
              })
              this.setState({
                listOfHotPositions: hotpreviousList.reverse()
              })
            }
            i++;
          })
        })
        const blogsRelatedRef = firebase.database().ref('MedicalTeamPosts/').limitToLast(4);
        blogsRelatedRef.on('value', snap => {
          snap.forEach((childArticle) => {
            const previousList = this.state.listOfPositions;

              previousList.push({
                RelatedblogName: childArticle.val().blogName,
                RelatedcreateDate: childArticle.val().createDate,
                RelatedcreateTime: childArticle.val().createTime,
                RelatedblogTag: childArticle.val().blogTag,
                RelatedsecondTag: childArticle.val().secondTag,
                RelatedotherTag1: childArticle.val().otherTag1,
                RelatedotherTag2: childArticle.val().otherTag2,
                RelatedlistPhoto: childArticle.val().croppedImg ? childArticle.val().croppedImg : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                Relatedid: childArticle.val().id,
                Relatedauthor: childArticle.val().author,
                RelatedauthorUrl: childArticle.val().authorUrl,
                RelatedName: childArticle.val().name,
                theAuthor: 'https://herbalcure.com.tw/MedicalTeams/' + childArticle.val().userId,
              })
              this.setState({
                listOfPositions: previousList.reverse()
              })

          })
        })
    }
    render() {
        const { loading } = this.state;
         if(loading) {
          return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
         }
        const listOfHotPositions = this.state.listOfHotPositions.map(position =>
            <article key={position.Hotid} className="postBox">
            <a href={'https://herbalcure.com.tw/AuthorityBlogs/' + position.Hotid}>
              <h1>{ position.HotblogName }</h1>
              <div className="postListBox">
               <img
                 src={position.HotlistPhoto} alt={position.HotblogTag} />
              </div>
            </a>
            <sub className="postListTagsBox">
             <Link to={"/AuthorityTag/" + position.HotblogTag}>{ position.HotblogTag }</Link>
             <Link to={"/AuthorityTags/" + position.HotsecondTag}>{ position.HotsecondTag }</Link>
             <Link to={"/AuthorityTagsa/" + position.HototherTag1} style={{display: position.HototherTag1 ? 'inline-block' : 'none'}}>{ position.HototherTag1 }</Link>
             <Link to={"/AuthorityTagsb/" + position.HototherTag2} style={{display: position.HototherTag2 ? 'inline-block' : 'none'}}>{ position.HototherTag2 }</Link>
            </sub>
            <sub style={{padding: '0 0 0 7px'}}>
              <a href={position.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {position.HotName}</a>
              <a href={position.HotauthorUrl} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>引用自: {position.Hotauthor}</a>
              <span>{position.HotcreateDate}</span> <span>{position.HotcreateTime}</span>
            </sub>
          </article>
         )
         const listOfPositions = this.state.listOfPositions.map(position =>
            <article key={position.Relatedid} className="postBox">
            <a href={'https://herbalcure.com.tw/AuthorityBlogs/' + position.Relatedid}>
              <h1>{ position.RelatedblogName }</h1>
              <div className="postListBox">
               <img
                 src={position.RelatedlistPhoto} alt={position.RelatedblogTag} />
              </div>
            </a>
            <sub className="postListTagsBox">
             <Link to={"/AuthorityTag/" + position.RelatedblogTag}>{ position.RelatedblogTag }</Link>
             <Link to={"/AuthorityTags/" + position.RelatedsecondTag}>{ position.RelatedsecondTag }</Link>
             <Link to={"/AuthorityTagsa/" + position.RelatedotherTag1} style={{display: position.RelatedotherTag1 ? 'inline-block' : 'none'}}>{ position.RelatedotherTag1 }</Link>
             <Link to={"/AuthorityTagsb/" + position.RelatedotherTag2} style={{display: position.RelatedotherTag2 ? 'inline-block' : 'none'}}>{ position.RelatedotherTag2 }</Link>
            </sub>
            <sub style={{padding: '0 0 0 7px'}}>
              <a href={position.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>發文者: {position.RelatedName}</a>
              <a href={position.RelatedauthorUrl} target="_blank" rel="noopener noreferrer" className="author" style={{display: position.Relatedauthor ? 'block' : 'none' , margin: '5px 0 -2px 0'}}>引用自: {position.Relatedauthor}</a>
              <span>{position.RelatedcreateDate}</span> <span>{position.RelatedcreateTime}</span>
            </sub>
          </article>
         )
        return(
            <section className="relatedArticleBox">
            <article>
                <h2>熱門文章</h2>
                {listOfHotPositions}
             </article>
             <article>
                 <h2>最新文章</h2>
                {listOfPositions}
             </article>
             <article>
              <AdSense.Google client='ca-pub-7635356603983362'
                            slot='2321261188'
                            format='auto'
                            className="adsbygoogle"
                            style={{display: 'block', marginTop: 20}} />
            </article>
           </section>
        )
    }
}
const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  }
}


// WEBPACK FOOTER //
// ./src/component/ADPost.js